import {buildStorageDataSet, getConnection} from '../_shared/GWTBridge/invoke/genPage';
import {buildServerCall} from './wcfService';

export function setStorageItem(key: string, value: string) {
    const featureDataSet = buildStorageDataSet(key, value);
    const params = {data: [featureDataSet]};
    buildServerCall('GeneralUserValuesSet', params, 'GeneralUserValuesSet', false, getConnection);
}

export function getStorageItem(key: string) {
    const dataSet = buildStorageDataSet(key, null);
    const params = {data: [dataSet]};
    return buildServerCall(
        'GeneralUserValuesGet',
        params,
        'GeneralUserValuesGet',
        false,
        getConnection
    ).then((res: any) => {
        return res?.General[0]?.UserValues[0];
    });
}
